import { IppUser } from '@rcp/types';

export interface UsersState {
	userDetails: IppUser;
}

export const initialUsersState: UsersState = {
	userDetails: {} as IppUser
};
